import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hr-portfolio-shell',
  templateUrl: './portfolio-shell.component.html',
  styleUrls: ['./portfolio-shell.component.less'],
  standalone: false,
})
export class PortfolioShellComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
